import { createSlice } from "@reduxjs/toolkit";
import { BOOKINK_SESSION } from "constants";
import { v4 as uuidv4 } from 'uuid';

const initialState = {
  sessionId: uuidv4(),
  reservationId: "no",
  expiryOn: new Date().getTime(),
  expiryIn: -1,
};

export const ticketReservationSlice = createSlice({
  name: "ticketreservation",
  initialState,
  reducers: {
    setReservationstate: (state, action) => {
      const now = new Date();
      const ttlMinutes = 8;
      let finalpayload = { ...state, ...action.payload }
      if (action.payload.expiryIn) {
        finalpayload.expiryOn = now.getTime() + ttlMinutes * 60 * 1000;
        finalpayload.expiryIn = ttlMinutes;
      }
      window.localStorage.setItem(`${BOOKINK_SESSION}`, JSON.stringify(finalpayload));
      return { ...finalpayload };
    },
    updateReservationstate: (state, action) => {
      window.localStorage.setItem(`${BOOKINK_SESSION}`, JSON.stringify({ ...state, ...action.payload }));
      return { ...state, ...action.payload };
    },
    deleteReservationstate: (state, action) => {
      let finalpayload = { ...state, ...action.payload }
      for (let index = 0; index < Object.keys(action.payload).length; index++) {
        const element = action.payload[index];
        delete finalpayload[element];
      }
      window.localStorage.setItem(`${BOOKINK_SESSION}`, JSON.stringify({ ...finalpayload }));
      return { ...finalpayload };
    },
    resetReservationstate: (state, action) => {
      let finalpayload = {
        // ...state,
        // ...action.payload,
        ...initialState,
      }
      
      window.localStorage.setItem(`${BOOKINK_SESSION}`, JSON.stringify({ ...finalpayload }));
      return { ...finalpayload };
    },
  },
});

export const { setReservationstate, updateReservationstate, deleteReservationstate, resetReservationstate } = ticketReservationSlice.actions;

export default ticketReservationSlice.reducer;
